module.exports = __webpack_public_path__ + "static/media/logo_tspace_sourcing.4ee64883.png";